import type { ICreateCollectionOrder } from '../../domain/use-cases/i-create-collection-order'
import type { CreateCollectionOrderRequest } from '../../domain/models/create-collection-order'
import type { ApiResponse } from '../../../../config/api-types'

export class CreateCollectionOrderController {
  constructor(private readonly repository: ICreateCollectionOrder) {}

  async create(params: CreateCollectionOrderRequest): Promise<ApiResponse> {
    try {
      const result = await this.repository.create(params)
      return result
    } catch (error) {
      throw error
    }
  }
}
